import { IMAGE_MIME_WILDCARD } from '@messenger/consts'
import * as S from './EditorToolbar.styled'

export const FileUploadHandler = ({ inputRef, onChange, children }) => (
  <>
    <S.HiddenInput
      ref={inputRef}
      onChange={onChange}
      type="file"
      accept={IMAGE_MIME_WILDCARD}
      data-testid="editor-toolbar-file-input"
    />
    {children}
  </>
)

export default FileUploadHandler
